// Vendor
// require('example-vendor');

// Modules
// require('./modules/simple-parallax');

import simpleParallax from 'simple-parallax-js';

import initAnchorScroll from './modules/initAnchorScroll';

import initAnchorActiveNav from './modules/anchor-active-nav.js';

import initMobileMenu from './modules/initMobileMenu';

import initMediaSlider from './modules/initMediaSlider';

import initGalleryArchive from './modules/initGalleryArchive';

import initGalleryDownload from './modules/initGalleryDownload';

import initGalleryBacktop from './modules/initGalleryBacktop';

import AOS from 'aos';

import { Fancybox } from "@fancyapps/ui/dist/fancybox";

import Splide from '@splidejs/splide';


import gsap from 'gsap';
import SplitType from 'split-type';

function initApp() {
  initAnchorScroll();
  initAnchorActiveNav();
  initMobileMenu();
  initGalleryArchive();
  initGalleryDownload();
  initGalleryBacktop();
}


Fancybox.bind('[data-fancybox="video-the-open"]', {
  dragToClose: true,
});






if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}

import './modules/scripts';


// Vendor
// https://michalsnik.github.io/aos/
// AOS


const isMobile = window.matchMedia('(max-width: 767px)').matches;

if (isMobile) {
  const playersAosItems = document.querySelectorAll('.c-players .js-players-aos');

  if (playersAosItems.length) {
    playersAosItems.forEach(function (item) {
      item.setAttribute('data-aos-duration', '450');
      item.setAttribute('data-aos-delay', '0');
      item.setAttribute('data-aos-offset', '0');
    });
  }
}










document.addEventListener('DOMContentLoaded', function () {

  const videoSlider = document.querySelector('.js-video-slider');

  if (videoSlider) {
    new Splide(videoSlider, {
      type: 'slide',
      perPage: 3,
      perMove: 1,
      gap: '24px',
      arrows: true,
      pagination: true,
      breakpoints: {
        1024: {
          perPage: 2,
        },
        640: {
          perPage: 2,
          gap: '16px',
        },
      },
    }).mount();
  }





  const banner = document.querySelector('.c-banner-open-tq');
  const title = document.querySelector('.js-title-split');
  const logos = document.querySelectorAll('.js-banner-logos img');

  if (banner && title && logos.length) {
    const splitTitle = new SplitType(title, {
      types: 'lines, words'
    });

    const bannerAnimation = gsap.timeline({
      paused: true
    });

    bannerAnimation
    .from(logos, {
      y: 24,
      opacity: 0,
      scale: 0.96,
      duration: 0.75,
      ease: 'power3.out',
      stagger: 0.15
    })
    .from(splitTitle.words, {
      y: 90,
      opacity: 0,
      rotateX: -45,
      duration: 1,
      ease: 'power4.out',
      stagger: 0.08
    }, '-=0.25');

    const observerBanner = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bannerAnimation.restart();
        } else {
          bannerAnimation.pause(0);
        }
      });
    }, {
      threshold: 0.35
    });

    observerBanner.observe(banner);
  }

  const hero = document.querySelector('.c-hero');

  if (hero) {
    const observerHero = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          hero.classList.remove('is-in-view');

          void hero.offsetWidth;

          hero.classList.add('is-in-view');
        } else {
          hero.classList.remove('is-in-view');
        }
      });
    }, {
      threshold: 0.35
    });

    observerHero.observe(hero);
  }


  AOS.init({
    duration: 1400,
    easing: 'ease-out-cubic',
    once: false,
    offset:0,
    mirror: true
  });

});

